<template>
  <component :is="resolveLayout">
    <router-view></router-view>
  </component>
</template>

<script>
import axios from 'axios'
import store from './store'
import { computed } from '@vue/composition-api'
import { useRouter } from '@/utils'
import LayoutBlank from '@/layouts/Blank.vue'
import LayoutContent from '@/layouts/Content.vue'

export default {
  components: {
    LayoutBlank,
    LayoutContent,
  },
  setup() {
    const { route } = useRouter()
    store.commit('initialiseStore')

    console.log(store.state.isAuthenticated)

    let token = store.state.token

    if (token) {
      axios.defaults.headers.common['Authorization'] = 'Token ' + token
    } else {
      axios.defaults.headers.common['Authorization'] = ''
    }

    const resolveLayout = computed(() => {
      // Handles initial route
      if (route.value.name === null) return null

      if (route.value.meta.layout === 'blank') return 'layout-blank'

      return 'layout-content'
    })
    return {
      resolveLayout,
    }
  },
}
</script>
<style>
/* style global, NON scoped */
body.chat-open {
  overflow: hidden;
  height: 100%;   /* nécessaire pour empêcher le scroll */
}
body.chat-open footer,
body.chat-open .footer,
body.chat-open .site-footer,
body.chat-open [class*="footer"],
body.chat-open [class*="copyright"] {
  display: none !important;
}
</style>
